import i18n from "../../plugins/i18n";
import iban from "iban";
export const rules = {
  data() {
    let vm = this;
    return {
      rules: {
        required: value => {
          let realValue = value;
          if (Array.isArray(value)) {
            realValue = Array.length;
          }
          if (typeof value === "object" && value !== null) {
            if (value instanceof File) {
              realValue = true;
            } else {
              realValue = Object.values(value).length;
            }
          }
          return !!realValue || i18n.t("validate.required");
        },
        requiredForDate(value) {
          let momentFormat = "DD.MM.YYYY";
          return (
            (value &&
              value.toLowerCase &&
              value.toLowerCase() !== momentFormat.toLowerCase() &&
              vm.rules.required(value)) ||
            i18n.t("validate.required")
          );
        },
        requiredWithNull(value) {
          return (
            value === null ||
            vm.rules.required(value) ||
            i18n.t("validate.required")
          );
        },
        requiredWithEmptyString(value) {
          return (
            value === "" ||
            vm.rules.required(value) ||
            i18n.t("validate.required")
          );
        },
        requiredWithUndefined(value) {
          return (
            value === undefined ||
            vm.rules.required(value) ||
            i18n.t("validate.required")
          );
        },
        passwordLength: value =>
          (value || "").length >= 8 ||
          i18n.t("validate.password-length", { length: 8 }),
        email: v =>
          typeof v === "undefined" ||
          v === null ||
          v === "" ||
          /.+@.+/.test(v) ||
          i18n.t("validate.email"),
        number: (options = {}) => value => {
          if (Number.parseFloat(value) + "" !== value + "") {
            return i18n.t("validate.should-be-number");
          }
          if (typeof options.max === "number" && +value > options.max) {
            return i18n.t("validate.should-be-smaller-or-eql", {
              value: options.max
            });
          }
          if (typeof options.min === "number" && +value < options.min) {
            return i18n.t("validate.should-be-bigger-or-eql", {
              value: options.min
            });
          }
          return true;
        },
        iban: v =>
          typeof v === "undefined" ||
          v === null ||
          v === "" ||
          iban.isValid(v) ||
          i18n.t("validate.iban")
      },
      errorsForRules: {
        // field: "Some errors"
      }
    };
  },
  methods: {
    backEndValidation(field) {
      return () => {
        let errorObject = this.errorsForRules[field];
        // if no find any errors
        if (!errorObject) return true;
        // if error like a string ('wrong passport')
        if (typeof errorObject === "string") {
          return errorObject;
        }
        // if error like a array (["The email has already been taken."])
        if (Array.isArray(errorObject)) {
          return errorObject.join(" ");
        }
        // if some error come like Object ({key:"some error"})
        if (typeof errorObject === "object") {
          return Object.values(errorObject).join(" ");
        }
        // If it comes in any strange way (null,function)
        return "Some error:" + errorObject.toString();
      };
    },
    errorHandler(callback, data = {}) {
      this.errorsForRules = data;
      callback(data);
    },
    clearBackEndErrors() {
      this.errorsForRules = {};
      this.clearErrorNotification();
    },
    clearErrorNotification() {
      this.$store.dispatch("notificationStore/hideNotificationsByKind", {
        kind: "NotificationForApiRequest"
      });
    }
  }
};
